<template>
  <div>
    <div :style="getMainSectionStyle()">
      <span class="image-overlay"></span>
      <div class="full-screen-image-with-text-wrapper  wow fadeIn delay-1s">
        <div class="full-screen-image-with-text-con">
          <div class="full-screen-image-with-text-title-con">
            <h1 v-html="productHeader.title[getIndex()]"></h1>
          </div>
          <p>
            {{ productHeader.discription[getIndex()] }}
          </p>
          <div class="full-screen-image-with-text-scrollcon">
            <router-link
              to=""
              v-scroll-to="{
                el: '#productcards',
                duration: 800,
                easing: 'ease-in'
              }"
              style="color: white;"
              class="round"
            >
              {{ $t("products") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div id="productcards" class="products-container">
      <ProductCard :products="listOfProducts" :showAllProductLink="false" />
    </div>
  </div>
</template>

<script>
import ProductCard from "./ProductCard";
import { mapGetters } from "vuex";

export default {
  name: "Products",
  components: {
    ProductCard
  },
  created() {
    window.scrollTo(0, 0);
  },
  computed: mapGetters(["productHeader", "listOfProducts"]),
  methods: {
    getIndex() {
      if (this.$i18n.locale === "ku") return 0;
      else if (this.$i18n.locale === "ar") return 1;
      else return 2;
    },
    getImage(location, name) {
      return require("../../assets/" + location + name);
    },
    getMainSectionStyle() {
      return {
        backgroundImage: `url(${this.getImage("", "mainbg.jpg")})`,
        width: "100%",
        height: "100vh",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.products-container {
  padding-top: 200px;
}

@media (max-width: 768px) {
  .products-container {
    padding-top: 100px;
  }
}
</style>
